import i18next from 'i18next';
import transliterator from '@sindresorhus/transliterate';
import split from 'lodash/split';

const splitSectorName = (string) => {
  let [firstWord, secondWord, ...rest] = split(string, '-', 2);

  if (secondWord) {
    return [firstWord, secondWord];
  }

  [firstWord, secondWord, ...rest] = split(string, ' ', 3);

  return [firstWord, secondWord, ...rest];
};

const transliterate = (sectorName: string) => {
  if (!i18next.language || i18next.language === 'ru') return sectorName;

  const [firstWord, secondWord, ...rest] = splitSectorName(sectorName);

  if (i18next.exists(firstWord)) {
    return `${i18next.t(firstWord)}${secondWord ? ` ${secondWord}` : ''} ${rest ? rest : ''}`;
  }

  return i18next.exists(sectorName) ? i18next.t(sectorName) : transliterator(sectorName);
};

export default transliterate;
